import { EntityAdapter } from 'vue-entity-adapter'

export const adapter = new EntityAdapter()

export default adapter